module.exports = __webpack_public_path__ + "img/blueberries.d8a1a0ef.png";